export enum Types {
    SUCCESS = "success",
    ERROR = "error",
    INFO = "info"
}
export enum SnackbarTypes {
    SUCCESS = "success",
    ERROR = "error",
    INFO = "info"
}